import React from "react";

import { GridResult } from "2g-grid";

import useZdrojeGrid from "./useZdrojeGrid";

export function ZdrojeGrid() {
  const grid = useZdrojeGrid();
  return <GridResult {...grid} />;
}

ZdrojeGrid.propTypes = {};

export default React.memo(ZdrojeGrid);
